export const ADD_COLLEGE = 'ADD_COLLEGE';
export const DELETE_COLLEGE = 'DELETE_COLLEGE';
export const ADD_STUDENT_COLLEGE = 'ADD_STUDENT_COLLEGE';
export const DELETE_STUDENT_COLLEGE = 'DELETE_STUDENT_COLLEGE';
export const SEARCH_COLLEGES = 'SEARCH_COLLEGES';